import { environment } from '../environments/environment';
var ɵ0 = environment.ES_REST_API, ɵ1 = environment.MASTER_REST_API, ɵ2 = environment.ANGEL_REST_API, ɵ3 = environment.COMMON_REST_API;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
